module.exports = __webpack_public_path__ + "static/home-half-stack-b5bb16f6b31587b37f7de252e4b94cfd.svg";